import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect, useRef } from 'react';
import { getSummaryForViewMode } from '../../../Attachments/InlineAttachment';
import { LOAD_TRANSFORMERS } from '../transformers';
import { $convertFromMarkdownString } from '@lexical/markdown';

import { useImpressionEditorContext } from '../../Context';

export const EditingPlugin = () => {
  const { isEditing, isSuggesting, activeImpression, viewMode, canAnnotate } =
    useImpressionEditorContext();
  const [editor] = useLexicalComposerContext();

  const hasDiffDocument = Boolean(activeImpression?.reviewDiffDocument);
  const editorContent =
    activeImpression?.reviewDiffDocument ?? activeImpression?.summary ?? '';

  const isEditingRef = useRef(isEditing);
  const isSuggestingRef = useRef(isSuggesting);
  const hasDiffDocumentRef = useRef(hasDiffDocument);
  const canAnnotateRef = useRef(canAnnotate);

  useEffect(() => {
    const editableChanged = isEditingRef.current !== isEditing;
    const suggestingChanged = isSuggestingRef.current !== isSuggesting;
    const diffDocChanged = hasDiffDocumentRef.current !== hasDiffDocument;
    const annotateChanged = canAnnotateRef.current !== canAnnotate;

    if (
      !editableChanged &&
      !suggestingChanged &&
      !diffDocChanged &&
      !annotateChanged
    ) {
      return;
    }

    const shouldBeEditable =
      (isEditing || canAnnotate) && !isSuggesting && !hasDiffDocument;

    if (shouldBeEditable) {
      editor.setEditable(true);
    } else {
      editor.setEditable(false);
      const shouldReloadContent =
        (editableChanged && !isEditing && !hasDiffDocument) ||
        (diffDocChanged && hasDiffDocument);
      if (shouldReloadContent) {
        editor.update(() => {
          $convertFromMarkdownString(
            getSummaryForViewMode(editorContent, viewMode),
            LOAD_TRANSFORMERS,
          );
        });
      }
    }

    isEditingRef.current = isEditing;
    isSuggestingRef.current = isSuggesting;
    hasDiffDocumentRef.current = hasDiffDocument;
    canAnnotateRef.current = canAnnotate;
  }, [
    isEditing,
    isSuggesting,
    hasDiffDocument,
    canAnnotate,
    editor,
    editorContent,
    viewMode,
  ]);

  return null;
};
